<template>
  <b-media class="media media-comment" no-body>
    
    <b-img alt="Image placeholder" rounded="circle" class="avatar avatar-lg media-comment-avatar" :src="comment.user.image ? comment.user.image.absoluteUri : '/img/DefaultUser.gif'" />
    <b-media-body class="media-body">
      <div class="media-comment-text">
        <div class="media-comment-head d-flex justify-content-between">
          <h6 class="h5 my-0">{{comment.user.firstName}}</h6>

          <p class="mb-0 mr--2">{{ formatDate(comment.createdOn) }}</p>
        </div>

        <div class="comment-data" :ref="comment.id">
          <p class="text-sm lh-160"
              :class="{ active: activeComment === comment.id }"
              @dblclick="handleEdit(comment.id,$event)" 
              v-html="comment.comment"></p>
          <div class="edit-form" :class="{ active: activeComment === comment.id }">
            <input class="" 
            v-model="comment.comment" 
            @keyup.enter="saveEdit(comment,$event)" 
            type="text" 
            v-if="isCommentOwner(comment.user.id)">
            <span class="btn btn-icon-only mr-0"
            @click="saveEdit(comment,$event)" >
              <i class="fas fa-save"></i>
            </span>
          </div>
        </div>
        <div class="icon-actions">
          <a href="#" class="like " @click="handleLike($event, comment)">
            <i class="ni ni-like-2"></i>
            <span class="text-muted">
              <slot v-if="comment.likes > 1">{{comment.likes}} {{ recipesData.comment_likes }}</slot>
              <slot v-if="comment.likes === 1">{{comment.likes}} {{ recipesData.comment_like }}</slot>
              <slot v-if="comment.likes < 1">{{ recipesData.comment_no_likes }}</slot>
            </span>
          </a>
          <a href="#">
            <i class="ni ni-curved-next"></i>
            <span class="text-muted">{{ recipesData.comment_reply }}</span>
          </a>

          <div class="comment-edit" v-if="isCommentOwner(comment.user.id)">
            <el-dropdown trigger="click" class="dropdown">
              <span class="btn btn-sm btn-icon-only text-light mr-0">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <b-dropdown-item v-if="isCommentOwner(comment.user.id)" @click.native="handleEdit(comment.id)">Edit</b-dropdown-item>
                <b-dropdown-item v-if="isCommentOwner(comment.user.id)" @click.native="handleDelete(comment)">Delete</b-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
       
      </div>

      <!--b-media class="media media-comment" no-body v-for="subcomment in comment.subcomments" :key="subcomment.index">
        <b-img alt="Image placeholder" rounded="circle" class="avatar avatar-lg media-comment-avatar" :src="subcomment.author_img" />
        <b-media-body class="media-body">
          <div class="media-comment-text">
            <div class="media-comment-head d-flex justify-content-between">
              <h6 class="h5 my-0">{{subcomment.author}}</h6>

              <p class="mb-0 mr--2">{{subcomment.date_created}}</p>
            </div>
            <p class="text-sm lh-160" v-html="subcomment.text"></p>
            <div class="icon-actions">
              <a href="#" class="like active" @click="handleLike($event, subcomment)">
                <i class="ni ni-like-2"></i>
                <span class="text-muted">
                  <slot v-if="subcomment.likes > 1">{{subcomment.likes}} {{ recipesData.comment_likes }}</slot>
                  <slot v-if="subcomment.likes === 1">{{subcomment.likes}} {{ recipesData.comment_like }}</slot>
                  <slot v-if="subcomment.likes < 1">{{ recipesData.comment_no_likes }}</slot>
                </span>
              </a>
              <a href="#">
                <i class="ni ni-curved-next"></i>
                <span class="text-muted">{{ recipesData.comment_reply }}</span>
              </a>
            </div>
          </div>
        </b-media-body>
      </b-media-->
    </b-media-body>
  </b-media>
</template>
<script>
  import { distanceInWords, addHours } from 'date-fns'
  import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
  import swal from 'sweetalert2'

  export default {
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      swal
    },
    name: 'comment',
    props: ["comment"],
    data() {
      return {
        data: null,
        activeComment: ''
      }
    },
    computed: {
      comments() {
        return Object.values(this.$store.state.comments.current);
      },
      recipesData() {
        return this.$store.state.recipes.current;
      },
      thisUser() {
        return this.$store.state.authentication.user.user;
      }
    },
    methods: {
      handleEdit(id, event) {
        this.activeComment = id;
      },
      saveEdit(comment, event) {
          
        const commentData = {
              id: comment.id,
              userId: comment.userId,
              recipeId: comment.recipeId,
              comment: comment.comment
          };
          try {
              this.$store.dispatch("comments/editComment", commentData)
                  .then(response => {
                    this.fetchComments();
                  }).catch(error => {
                      console.log('Something went wrong: ', error);
                  });
          } catch (error) {
              console.log("Error: Comment", error);
          }


        this.activeComment = '';
      },
      handleLike(event, comment) {
        event.preventDefault();

        const likeButton = event.target.closest('.like');

        if (likeButton) {
          likeButton.classList.contains('active') ? recipe.likes-- : recipe.likes++;
          likeButton.classList.toggle('active');
        }
      },
      handleDelete(comment) {
        swal.fire({
          title: 'Delete Comment?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes!',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
          const { dispatch } = this.$store;

          try {
                dispatch("comments/removeComment", comment.id)
                    .then(response => {
                      this.fetchComments();
                }).catch(error => {
                    console.log('Something went wrong: ', error);
                });
            } catch (error) {
                console.log("Error:", error);
            }
          }


        });
      },
      isCommentOwner(commentUserId) {
        if ( this.thisUser.id == commentUserId ) {
          return true
        }
        return false
      },
      fetchComments() {
          const commentData = {
              recipeId: this.comment.recipeId
          };
          try {
              this.$store.dispatch("comments/getComments", commentData)
                  .then(response => {
                  }).catch(error => {
                      console.log('Something went wrong: ', error);
                  });
          } catch (error) {
              console.log("Error: Favorite", error);
          }
      },
      formatDate: function (date) {
        const serverTime = addHours(new Date(), 5)
        const commentDate = distanceInWords(date,serverTime)
        return `${commentDate} ago`
      },
    }
  }
</script>
<style>

.comment-edit {
  float: right;
  margin: 0 0 20px 0;
}
.edit-form, .comment-data p.active {
  display:none;
}
.edit-form.active {
  display: block;
}
</style>
